import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { LazyLoadEvent } from 'primeng/api/public_api';
import { Table } from 'primeng/table';
import { SimuladorService } from 'src/app/datos/simulador.service';
import { FormValidation } from 'src/app/libs/ruvpp-angular2-comun/FormValidation';
import { ServicioIndicadorCarga } from 'src/app/libs/ruvpp-angular2-comun/indicador-carga';
import { JsonResponse } from 'src/app/libs/ruvpp-angular2-comun/modelo/Index';
import { ServicioAlertas } from 'src/app/libs/ruvpp-angular2-comun/ServicioAlertas';
import { DatosElementoDTO, ElementosForm, InputObtenerEspacio_Pages, OutputObtenerElementos_Pages, OutputObtenerEspacio_Pages, EspacioForm, InputActualizarEstatusEspacio, EspacioDTO, ElementoDTO, OutputObtenerElementos, InputAgregarEspacio, OutputAgregarEspacio, InputObtenerEspacioDetalle, OutputObtenerEspacioDetalle } from 'src/app/modelo';
import Swal from 'sweetalert2/dist/sweetalert2.js';
import { MenuComponent } from '../menu/menu.component';
import { SelectItemGroup, Message, MessageService } from 'primeng/api';

@Component({
    selector: 'app-catalogo-espacios',
    templateUrl: './catalogo-espacios.component.html',
    //styleUrls: ['../../../assets/css/styles.css', '../../../assets/css/bootstrap.css']
})
export class CatalogoEspaciosComponent implements OnInit {

    public datosElementoDTO: DatosElementoDTO;
    public modalTitulo: string;
    public modal: boolean = false;

    @ViewChild('tabla') tabla: Table;
    public isLoading: boolean;
    public espacioDTO: OutputObtenerEspacio_Pages;
    public filtro: EspacioForm;
    public entidad: EspacioForm;
    public idElemento: number | null;
    public grupoElementos: SelectItemGroup[];

    //Validaciones

    public NombreEspacio_MensajeError: FormValidation = new FormValidation(null);
    public ListaElementos_MensajeError: FormValidation = new FormValidation(null);
    public TipoEspacio_MensajeError: FormValidation = new FormValidation(null);
    public TipoEtapa_MensajeError: FormValidation = new FormValidation(null);
    public TipoPiso_MensajeError: FormValidation = new FormValidation(null);



    //Menu

    public menu: MenuComponent;

    /**
     * 
     * @param servicioIndicadorCarga
     * @param servicioAlertas
     * @param service
     * @param _router
     */
    constructor(private servicioIndicadorCarga: ServicioIndicadorCarga, private servicioAlertas: ServicioAlertas, private service: SimuladorService, private _router: Router) {
        this.menu = new MenuComponent(_router);
    }

    /**
     * 
     */
    ngOnInit() {
        this.init();
        this.loading();
    }

    /**
    * 
    */
    private init(): void {
        this.filtro = <EspacioForm>{};
        this.espacioDTO = <OutputObtenerEspacio_Pages>{ listEspacios: [], totalRecords: 0 };
        this.entidad = <EspacioForm>{ listaElementos: [] };
        this.initValidacion();
    }

    /**
     * 
     */
    private initValidacion(): void {
        this.NombreEspacio_MensajeError = new FormValidation(null);
        this.ListaElementos_MensajeError = new FormValidation(null);
        this.TipoEspacio_MensajeError = new FormValidation(null);
        this.TipoEtapa_MensajeError = new FormValidation(null);
        this.TipoPiso_MensajeError = new FormValidation(null);
    }

    /**
     * 
     */
    private loading(): void {

        this.service.ObtenerElementos().subscribe((resultado: JsonResponse<DatosElementoDTO>) => {

            if (resultado != null && resultado.code == 200 && resultado.model != null) {

                this.datosElementoDTO = resultado.model;

                this.setFilter(this.datosElementoDTO, this.filtro);

                this.grupoElementos = [];

                for (let tipoElemento of this.datosElementoDTO.listTipoElementos) {

                    let filter: any = this.datosElementoDTO.listElementos.filter(row => row.idTipoElemento == tipoElemento.idTipoElemento);

                    let items: any[] = [];

                    for (let elemento of filter) {
                        items.push({ label: elemento.nombreElemento, value: elemento.idElemento });
                    }

                    let dato: any = {
                        label: tipoElemento.nombreTipoElemento,
                        items: items
                    };

                    this.grupoElementos.push(dato);

                }

            }
        });
    }

    /**
     * 
     */
    public nuevoRegistro(): void {

        this.initValidacion();

        this.entidad = <EspacioForm>{ idEspacio: null, listaElementos: [] };

        this.idElemento = null;

        this.setFilter(this.datosElementoDTO, this.entidad)

        this.modalTitulo = 'Agregar registro';

        this.showModalEditar();
    }

    /**
     * 
     * @param entity
     */
    public editar(entity: EspacioDTO): void {

        this.initValidacion();

        this.entidad = <EspacioForm>{ typeView: 'Editar', etapa: entity.idEtapa, piso: entity.idPiso, tipoEspacio: entity.idTipoEspacio };

        this.idElemento = null;

        this.setFilter(this.datosElementoDTO, this.entidad)

        this.modalTitulo = 'Editar registro';

        this.getEspacio(entity.idEspacio)

        this.showModalEditar();
    }

    /**
     * 
     * @param entity
     */
    public clonar(entity: EspacioDTO): void {

        this.initValidacion();

        this.entidad = <EspacioForm>{ typeView: 'Clonar', etapa: entity.idEtapa, piso: entity.idPiso, tipoEspacio: entity.idTipoEspacio };

        this.idElemento = null;

        this.setFilter(this.datosElementoDTO, this.entidad)

        this.modalTitulo = 'Agregar registro';

        this.getEspacio(entity.idEspacio)

        this.showModalEditar();
    }

    /**
     * 
     */
    public guardar(): void {

        if (!this.validarFormumlario()) {

            let espacio: InputAgregarEspacio = <InputAgregarEspacio>{
                idEspacio: this.entidad.idEspacio,
                nombreEspacio: this.entidad.nombreEspacio,
                idTipoEspacio: this.entidad.tipoEspacio,
                listElementos: this.entidad.listaElementos,
                idPiso: this.entidad.piso,
                idEtapaPrototipo: this.entidad.etapa
            };

            this.service.AgregarEspacio(espacio).subscribe((resultado: JsonResponse<OutputAgregarEspacio>) => {

                if (resultado != null && resultado.code == 200 && resultado.model != null) {

                    this.closeModal();

                    this.Filtrar();

                    this.servicioAlertas.mostrarConOpciones({
                        title: "Simulador",
                        text: `Información guardada correctamente ...`,
                        icon: "success",
                        showCancelButton: false,
                        confirmButtonColor: '#3085d6',
                        cancelButtonColor: '#d33',
                        confirmButtonText: 'Aceptar',
                        cancelButtonText: 'Cancelar'
                    }).then((result) => {


                    })

                } else {

                    this.servicioAlertas.mostrarConOpciones({
                        title: "Simulador",
                        text: `Error al guardar la información...`,
                        icon: "error",
                        showCancelButton: false,
                        confirmButtonColor: '#3085d6',
                        cancelButtonColor: '#d33',
                        confirmButtonText: 'Aceptar',
                        cancelButtonText: 'Cancelar'
                    }).then((result) => {

                    })

                }

            });

        }
    }

    /**
    * 
    * @param tipo
    */
    public actualizarErrores(tipo: string) {

        switch (tipo) {
            case 'NombreEspacio':
                this.NombreEspacio_MensajeError = new FormValidation(this.entidad.nombreEspacio).requered('El nombre del espacio es obligatorio.');
                break;

            case 'TipoEspacio':
                this.TipoEspacio_MensajeError = new FormValidation(this.entidad.tipoEspacio).requered('El tipo de espacio es obligatorio.');
                break;

            case 'TipoEtapa':
                this.TipoEtapa_MensajeError = new FormValidation(this.entidad.etapa).requered('El tipo de etapa es obligatorio.');
                break;

            case 'TipoPiso':
                this.TipoPiso_MensajeError = new FormValidation(this.entidad.piso).requered('El tipo de piso es obligatorio.');
                break;

            case 'ListaElementos':

                this.ListaElementos_MensajeError = new FormValidation(null);

                if (this.entidad.listaElementos.length == 0) {
                    this.ListaElementos_MensajeError.requered('Debe de ingresar al menos un elemento en la lista');
                }

                break;
        }

    }

    /**
     * 
     */
    public validarFormumlario(): boolean {

        var error = false;

        this.NombreEspacio_MensajeError = new FormValidation(this.entidad.nombreEspacio).requered('El nombre del espacio es obligatorio.');

        if (this.NombreEspacio_MensajeError.error) {
            error = true;
        }

        this.ListaElementos_MensajeError = new FormValidation(null);

        if (this.entidad.listaElementos.length == 0) {
            this.ListaElementos_MensajeError.requered('Debe de ingresar al menos un elemento en la lista');
        }

        if (this.ListaElementos_MensajeError.error) {
            error = true;
        }

        this.TipoEspacio_MensajeError = new FormValidation(this.entidad.tipoEspacio).requered('El tipo de espacio es obligatorio.');

        if (this.TipoEspacio_MensajeError.error) {
            error = true;
        }

        this.TipoEtapa_MensajeError = new FormValidation(this.entidad.etapa).requered('El tipo de etapa es obligatorio.');

        if (this.TipoEtapa_MensajeError.error) {
            error = true;
        }

        this.TipoPiso_MensajeError = new FormValidation(this.entidad.piso).requered('El tipo de piso es obligatorio.');

        if (this.TipoPiso_MensajeError.error) {
            error = true;
        }

        return error;
    }

    /**
     * 
     */
    public closeModal(): void {
        this.modal = false;
    }

    /**
     * 
     */
    public showModalEditar(): void {
        this.modal = true;
    }

    /**
     * 
     * @param entity
     * @param form
     */
    private setFilter(entity: DatosElementoDTO, form: EspacioForm): void {
        form.listTipoEspacio = entity.listTipoEspacio;
        form.listEtapa = entity.listEtapa;
        form.listPiso = entity.listPiso;
    }

    /**
     * 
     */
    public Limpiar(): void {
        this.init();
        this.setFilter(this.datosElementoDTO, this.filtro);
        this.Filtrar();
        this.tabla._rows = 10;
    }

    /**
     * 
     */
    public Filtrar(): void {
        this.loadCarsLazy(null);
    }

    /**
     * 
     * @param event
     */
    public loadCarsLazy(event: LazyLoadEvent) {

        this.isLoading = true;

        //in a real application, make a remote request to load data using state metadata from event
        //event.first = First row offset
        //event.rows = Number of rows per page
        //event.sortField = Field name to sort with
        //event.sortOrder = Sort order as number, 1 for asc and -1 for dec
        //filters: FilterMetadata object having field as key and filter value, filter matchMode as value

        //imitate db connection over a network

        console.log('event -->> ', event);

        let page: number = 1;
        let tamanioPagina = 10;

        if (event != null && event.first != null) {
            page = (event.first + event.rows) / event.rows;
            tamanioPagina = event.rows;
        }

        let data: InputObtenerEspacio_Pages = <InputObtenerEspacio_Pages>{
            tamanioPagina: tamanioPagina,
            pagina: page,
            nombreEspacio: this.filtro.nombreEspacio,
            idTipoEspacio: this.filtro.tipoEspacio,
            idPiso: this.filtro.piso,
            idEtapa: this.filtro.etapa
        };

        setTimeout(() => {

            this.service.ObtenerEspacioPages(data).subscribe((resultado: JsonResponse<OutputObtenerEspacio_Pages>) => {

                if (resultado != null && resultado.code == 200 && resultado.model != null) {
                    this.espacioDTO = resultado.model;
                }

                this.isLoading = false;
            });

        }, 1000);
    }

    /**
     * 
     * @param entity
     */
    public onChangePublicar(entity: EspacioDTO): void {

        if (entity.activo == false) {
            entity.activo = null;
        }

        let dato: InputActualizarEstatusEspacio = <InputActualizarEstatusEspacio>{ idEspacios: [entity.idEspacio], activo: entity.activo };

        this.service.ActualizarEstatusEspacio(dato).subscribe(resultado => {

        });

    }

    /**
     * 
     * @param entity
     */
    public delete(entity: EspacioDTO): void {

        this.servicioAlertas.mostrarConOpciones({
            title: "Simulador",
            text: `Está seguro de eliminar el espacio [ ${entity.nombreEspacio} ]`,
            icon: "question",
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#3085d6',
            confirmButtonText: 'Si',
            cancelButtonText: 'No'
        }).then((result) => {

            if (result.value) {

                let dato: InputActualizarEstatusEspacio = <InputActualizarEstatusEspacio>{ idEspacios: [entity.idEspacio], activo: false };

                this.service.ActualizarEstatusEspacio(dato).subscribe(resultado => {
                    this.Filtrar();
                });

            }

        })

    }

    /**
     * 
     */
    public addElemento(): void {

        let entity: OutputObtenerElementos = this.datosElementoDTO.listElementos.filter(row => row.idElemento == this.idElemento)[0];

        let elemento: ElementoDTO = <ElementoDTO>{
            idElemento: entity.idElemento,
            nombreElemento: entity.nombreElemento,
            clave: entity.clave,
            idTipoDatoEntrada: entity.idTipoDatoEntrada,
            idTipoElemento: entity.idTipoElemento,
            unidadMedida: entity.unidadMedida,
            nombreTipoDatoEntrada: entity.nombreTipoDatoEntrada,
            nombreTipoElemento: entity.nombreTipoElemento,
            idManoObra: entity.idManoObra,
            largo: 0,
            anchoCantidad: 0
        };

        if (elemento.idTipoDatoEntrada == 1) {
            elemento.largo = 1;
        }

        this.entidad.listaElementos.push(elemento);

        this.actualizarErrores('ListaElementos');

    }

    /**
     * 
     * @param entity
     */
    public deleteElemento(entity: ElementoDTO): void {

        const index = this.entidad.listaElementos.findIndex(row => row == entity);

        this.entidad.listaElementos.splice(index, 1);

    }

    /**
     * 
     * @param idEspacio
     */
    private async getEspacio(idEspacio: number) {

        let dato: InputObtenerEspacioDetalle = <InputObtenerEspacioDetalle>{ idEspacio: idEspacio };

        let resultado: JsonResponse<OutputObtenerEspacioDetalle> = await this.service.ObtenerEspacioDetalle(dato).toPromise();

        if (resultado != null && resultado.code == 200 && resultado.model != null) {

            if (this.entidad.typeView == 'Detalle' || this.entidad.typeView == 'Editar') {
                this.entidad.idEspacio = resultado.model.espacio.idEspacio;
                this.entidad.nombreEspacio = resultado.model.espacio.nombreEspacio;
            }

            this.entidad.listaElementos = [];

            if (resultado.model.listElementos != null) {

                this.entidad.listaElementos = resultado.model.listElementos;

                for (let row of this.entidad.listaElementos) {
                    row.nombreElemento = row.nombreElementoEsp;
                }
            }

        }

    }
}